import React from 'react';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';


export default function ServiceConfirmationModeField({
  value = 'automatic',
  onChange,
  labels,
  disabled = false,
  hidden = false,
}) {
  if (hidden) {
    return null;
  }

  return (
    <FormControl>
      <FormLabel>{labels.title}</FormLabel>
      <RadioGroup
        value={value}
        onChange={(event) => onChange(event.target.value)}
      >
        <FormControlLabel
          value="automatic"
          control={<Radio />}
          label={labels.automatic}
          disabled={disabled}
        />
        <FormControlLabel
          value="manual"
          control={<Radio />}
          label={labels.manual}
          disabled={disabled}
        />
      </RadioGroup>
    </FormControl>
  );
}
